import ReactDOM from "react-dom";
import "sanitize.css";
import * as Sentry from "@sentry/react";

import "@src/config/i18n/i18next";
import Root from "@src/config/Root";
import "@src/index.css";
import isDevelopment from "@src/common/helpers/isDevelopment";

if (!isDevelopment()) {
  Sentry.init({
    dsn: "https://0b5101bd73b142b09956c690f96f1ae0@o4510977618935808.ingest.de.sentry.io/4510977789067344",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.render(<Root />, document.getElementById("root"));
